import { Get, Post } from "../utils/http-utils";

export const getAssetsForBrowser = async (queryParams = {}) => {
    return Get("/product/search", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const muteDevice = (requestBody) => {
    return Post("/device-management/mute", requestBody)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const unmuteDevice = (requestBody) => {
    return Post("/device-management/unmute", requestBody)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

